<template>
  <div>
    <el-dialog
      title="Выбор карты"
      append-to-body
      destroy-on-close
      :visible.sync="show"
      :width="width"
      top="2vh"
      :close-on-click-modal="false"
    >
      <el-row>
        <cards-component
          class="CardSelectModalCardsComponent"
          hide-last-column
          @selection-changed="cardSelected"
        ></cards-component>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="show = false">Закрыть</el-button>
      </div>
    </el-dialog>

    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>

import { off, on } from "element-ui/src/utils/dom";
import CardsComponent from "@/components/cards/CardsComponent";

export default {
  name: "cards-select-modal",
  components: {CardsComponent},
  props: {
    method: Function,
    params: Object,
    width: {
      type: String,
      default: '95%'
    },
  },

  data() {
    return {
      show: false,
      loading: false,

    }
  },
  mounted() {
    if (this.$refs.wrapper.children) {
      on(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  beforeDestroy() {
    if (this.$refs.wrapper.children) {
      off(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  methods: {
    showModal() {
      this.show = true;
    },

    cardSelected(card){
      this.$emit('card-selected', card);
      this.show = false;
    }

  },



}
</script>

<style>
.CardSelectModalCardsComponent tr:hover{
  cursor: pointer;
}
</style>